<template>
  <div id="room-amenity" class="grid">
    <div class="grid-title">
      <h4>{{ $t("ROOM_AMENITIES") }}</h4>
      <v-btn color="primary" class="pr-10 pl-10" @click="save" :loading="loading">{{ $t("SAVE") }}</v-btn>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <div v-for="(group, groupIndex) in data" :key="group.id">
        <hr v-if="groupIndex">
        <label class="label-title">
          {{
            group.i18ns.find(x => x.lang == defaultI18n).name
          }}
        </label>

        <v-row class="amenity-group">
          <v-col sm="6" md="4" v-for="amenity in group.amenities" :key="amenity.id" class="py-1">
            <v-flex class="d-flex align-start amenity">
              <span></span>
              <span :class="
                'icon-' +
                amenity.i18ns
                  .find(x => x.lang == 'en')
                  .name.replace('(', '')
                  .replace(')', '')
                  .replace(' - ', '-')
                  .split(/[/&\s,]+/)
                  .join('-') +
                '_ic'
              "></span>
              <v-checkbox :label="amenity.i18ns.find(x => x.lang == defaultI18n).name" color="indigo darken-3" class="m-0 pt-0"
                :value="amenity.id" v-model.lazy="installedAmenityIds[groupIndex].amenityIds" />
              <v-spacer />
              <div v-if="
                installedAmenityIds[groupIndex].amenityIds &&
                installedAmenityIds[groupIndex].amenityIds.includes(
                  amenity.id
                )
              " class="am-btn fee" :class="{ free: amenity.free }" @click="amenity.free = !amenity.free">{{
  amenity.free ? $t("FREE") : $t("SURCHARGE") }}</div>
            </v-flex>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { _alert } from "@/_helpers/function.js";
export default {
  props: {
    //amenities: Array
  },
  data() {
    return {
      isCreate: false,
      amenities: [],
      lang: this.$i18n.locale,
      data: [],
      installedAmenityIds: [],
      loading: false
    };
  },
  created() {
    this.inititalize();
  },
  mounted() {
    document.querySelectorAll(".v-tab.v-tab--active").forEach(x => {
      x.classList.remove("v-tab--active");
    });
    document
      .querySelector(".v-tab[tabIndex='1']")
      .classList.add("v-tab--active");
    if (
      document
        .querySelector(".v-tab[tabIndex='1']")
        .classList.contains("v-tab--disabled")
    ) {
      this.isCreate = true;
      document
        .querySelector(".v-tab[tabIndex='1']")
        .classList.remove("v-tab--disabled");
    }
  },
  methods: {
    async inititalize() {
      let roomId = this.$route.params.id;
      if (roomId) {
        await service.getRoomDetail(roomId).then(res => {
          if (res.responseCode == 0) {
            this.amenities = res.data.amenities;
          }
        });
      }
      await service.getRoomAmenities(roomId).then(res => {
        this.data = res.data;
        res.data.forEach(x => {
          this.installedAmenityIds.push({
            groupId: x.id,
            amenityIds: []
          });
        });
      });

      this.amenities.forEach(x => {
        let amenityId = x.id;
        let free = x.free;
        let groupId;
        this.data.forEach(x => {
          let amenity = x.amenities.find(x => x.id == amenityId);
          if (amenity) {
            groupId = x.id;
            amenity.free = free;
          }
        });
        this.installedAmenityIds
          .find(x => x.groupId == groupId)
          .amenityIds.push(x.id);
      });
    },
    save() {
      this.loading = true;
      let roomId = this.$route.params.id;
      let data = [];
      this.installedAmenityIds.forEach(x => {
        let groupId = x.groupId;
        data = data.concat(
          x.amenityIds.map(x => {
            let amenityId = x;
            return {
              id: x,
              free: this.data
                .find(x => x.id == groupId)
                .amenities.find(x => x.id == amenityId).free
            };
          })
        );
      });
      let temp = data.map(x => {
        return {
          id: x.id,
          free: x.free
        };
      });
      service.updateRoomAmenities(roomId, temp).then(res => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          if (this.isCreate) {
            this.$router.push({
              name: "roomImages",
              params: { id: this.$route.params.id }
            });
          } else {
            window.location.reload();
          }
          //this.$emit("nextTab");
        }
      });
    }
  }
};
</script>
